import { Tags } from "../../tags";
import { useTag } from "./useTags";
import { isEmail } from "../../../utils/string-templater";

// New-system tag paths (e.g. "employee.email", "datasets.<key>.<field>") are dotted, unwrapped
// resource paths, unlike the old "{{tag}}" wrapped format, but both represent a dynamic field.
export const isTagPath = (value: string) => Tags.isTag(value) || (value.includes(".") && !isEmail(value));

// Legacy employee-field selections were stored as a bare key (e.g. "emailwork"), not the
// dotted "employee.emailwork" path the new tag tree expects (which errors on a 1-segment path)
// - normalize the same way AttendToEventStepEditor's normalizeFieldPath already does.
const normalize = (path: string) => {
  const unwrapped = Tags.path(path);
  return unwrapped.includes(".") ? unwrapped : `employee.${unwrapped}`;
};

export const TagPathTitle = ({
  path,
  workflowId,
  fallback
}: {
  path: string;
  workflowId?: string;
  fallback?: string;
}) => {
  const normalized = normalize(path);
  const { tag, loading } = useTag(normalized, workflowId, { enabled: !!normalized });
  return <>{tag?.fullTitle ?? tag?.title ?? fallback ?? (loading ? "" : normalized)}</>;
};
